import { Link2 , Link2Off } from "lucide-react";

type LinkIconProps = {
  url: string | null | undefined;
};

function normalizeUrl(url: string): string {
    if (!/^https?:\/\//i.test(url)) {
      return 'https://' + url;
    }
    return url;
  }

  
export default function LinkIcon({ url }: LinkIconProps) {
  const isValid = typeof url === "string" && url.trim() !== "";

  return isValid ? (
    <a
      href={normalizeUrl(url)}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 hover:text-blue-800 ms-2"
    >
     <Link2 className="w-5 h-5 hover:text-greenBg"  />
    </a>
  ) : (
    <span className="text-muted ms-2" style={{ cursor: "not-allowed", opacity: 0.5 }}>
     <Link2Off className="w-5 h-5"  />
    </span>
  );
}
